import { render, staticRenderFns } from "./ChooseTransformsDialog.vue?vue&type=template&id=55b1bdc7&"
import script from "./ChooseTransformsDialog.vue?vue&type=script&lang=js&"
export * from "./ChooseTransformsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports